<template lang="pug">
// a revoir la condition
nav.navbar.navbar-expand-lg.fixed-top(:class="{ '': homeMenu === true, 'navbar-light bg-white shadow': homeMenu === false }", :style='fixedBarStyles')
  .admin-menu-bar.bg-primary.shadow-lg(v-if="isImpersonating", style='width:100%; transform:translateY(-15px)')
    .container
      h4.text-light.text-center.m-0.p-1
        i.fa.fa-exclamation-circle.mr-2
        |Vous êtes connecté à un compte utilisateur tierce. Cette session va expirer dans {{ impersonationTimer }} secondes
        a.ml-2.btn.btn-outline-light(@click.prevent="stopImpersonating(true)", href="")
          i.fa.fa-user-secret.mr-2
          |Quiter la session
  .container
    // a.navbar-brand(href='#')
    router-link(to='/', tag='a', class="navbar-brand")
      img.d-none.d-sm-block(:src="logo", width="120" alt="", srcset="")
      img.d-block.d-sm-none(:src="logo2", width="120" alt="", srcset="")
    button.navbar-toggler(
      type='button',
      data-toggle='collapse',
      data-target='#tf_navbar',
      aria-controls='tf_navbar',
      aria-expanded='false',
      aria-label='Toggle navigation',
      @click.prevent="display = !display")
      span.tf_sprite.tf_mobile_humberger
    #tf_navbar.collapse.navbar-collapse(:class= "{ 'show': display, '': !display }")
      ul.navbar-nav.ml-auto
        router-link(to='/', tag='li', class="nav-item", exact, @click.native='closeLogin()')
          a.nav-link {{ $t('menu.home') }}
        router-link(to='/tfabonnement', tag='li', class="nav-item",  @click.native='closeLogin()', v-if='isAuth & profil.canSubscribe')
          a.nav-link Abonnement
        router-link(to='/listappeloffre', tag='li', class="nav-item", @click.native='closeLogin()')
          a.nav-link {{ $t('menu.appeloffre') }}
        <!--fixme-->
        router-link(to='/listentreprise', tag='li', class="nav-item", @click.native='closeLogin()', v-if='canVieWEn()')
          a.nav-link Entreprises
        li.nav-item
          a.nav-link(href='http://blog.tendfox.com/') Actualités
        router-link(to='/faq', tag='li', class="nav-item", @click.native='closeLogin()')
          a.nav-link Aide
        router-link(to='/login', tag='li', class="nav-item d-block d-md-none", @click.native='closeLogin()', v-if='!isAuth')
          a.nav-link Connexion
        li.nav-item.dropdown.d-none.d-md-block(v-if='!isAuth', v-click-outside="onClickOutside")
          button.nav-link.text-primary.btn-link.border-0(@click="updateShowLogin(!showLogin)",) Connexion
          // include connexionForm
          transition(tag="span", name="fade")
            .dropdown-menu.tf_login(v-show="showLogin")
                h3.dropdown-header(v-if='resetpassword === false') Login
                .px-2.py-3(v-if='resetpassword === false')
                  .form-group
                      input.form-control(:data-vv-as="$t('user.email')" autocomplete='off', placeholder='Email', name='email', v-model='email', data-vv-name="email", type="email", v-validate="'required|email'", data-vv-rules="required|email", @blur.once='hasBlurred.email = true', :class='{"is-invalid": errors.has("email") && hasBlurred.email}')
                      .invalid-feedback(v-show="errors.has('email') && hasBlurred.email") {{errors.first('email')}}
                  .form-group
                      input.form-control(:data-vv-as="$t('user.password')" type='password', autocomplete='off', placeholder='Mot de passe', v-model='password', required='', data-vv-name="password", v-validate="'required|min:8'", name="password", data-vv-rules="required|min:5", @blur.once='hasBlurred.password = true', :class='{"is-invalid": errors.has("password") && hasBlurred.password}'  @keyup.enter="login")
                      .invalid-feedback(v-show="errors.has('password') && hasBlurred.password") {{errors.first('password')}}
                  button.btn.btn-primary.w-100.rounded-0.font-weight-bold.text-uppercase(type='submit', @click.prevent="login") Connexion
                .dropdown-divider.mx-2
                a.dropdown-item.text-center.actions(href='#',@click.prevent="resetpassword = true" v-show='resetpassword === false') Mot de passe oublié?
                h3.dropdown-header(v-if='resetpassword === true') Réinitialisation de mot de passe
                .px-2.py-3(v-if='resetpassword === true')
                  .form-group(v-show='!messageReset')
                      p  Veuillez entrer votre adresse email
                      input.form-control(:data-vv-as="$t('user.email')"  placeholder='Adresse e-mail', name='emaillost', v-model='emailReset', data-vv-name="emaillost", type="email", v-validate="'required|email'", data-vv-rules="required|email",  @blur.once='hasBlurred.emaillost = true', :class='{"is-invalid": errors.has("emaillost") && hasBlurred.emaillost}' , @keyup.enter="resetEmail")
                      .invalid-feedback(v-show="errors.has('emaillost') && hasBlurred.emaillost") {{errors.first('emaillost')}}
                  button.btn.btn-primary.w-100.rounded-0.font-weight-bold.text-uppercase(type='submit',  @click.prevent="resetEmail", v-show='!messageReset') Envoyez
                  // p(v-show='messageReset')
                    | Veuillez vérifier votre boîte de réception et cliquez sur le lien sécurisé
                  .alert.alert-success(v-show="messageReset")
                    button.close(data-close='alert')
                    span Veuillez vérifier votre boîte de réception et cliquez sur le lien sécurisé
                    p
                      | Si vous ne recevez pas notre message, vérifiez dans les courriers indésirables de votre messagerie
                .dropdown-divider.mx-2(v-show='resetpassword === true')
                a.dropdown-item.actions.text-center(href='#',@click.prevent="resetpassword = false" v-show='resetpassword === true') Connexion
        router-link(to='/register', tag='li', class="nav-item", v-if='!isAuth', @click.native='closeLogin()')
          a.nav-link.text-primary(href='#') {{ $t('menu.inscription') }}
        //li(class="nav-item", v-show='isAuth')
          a(href="#", @click='logout', class="nav-link")
            |  {{ $t('dropdown-menu.deconnexion') }}
        li.nav-item.dropdown(v-if='isAuth', v-click-outside="onClickOutside", v-show='isAuth')
          button.dropdown-toggle.nav-link.text-primary.btn-link.border-0(@click="showProfil = !showProfil")
            i.fa.fa-user.fa-lg
            |  {{profil.nom}}
          transition(tag="span", name="fade")
            .dropdown-menu.tf_login(aria-labelledby='dropdownMenuButton',  v-show='showProfil')
              router-link(to='/profil', tag='a' @click.native='closeLogin()' class="dropdown-item actions") {{ $t('dropdown-menu.profil') }}
              router-link(to='/monabonnement', tag='a' @click.native='closeLogin()' class="dropdown-item actions") {{ $t('dropdown-menu.abonnements') }}
              <!--fixme-->
              router-link(to='/profil/entreprise', tag='a', @click.native='closeLogin()', class="dropdown-item actions", v-if='canVieWEn()' ) Mon entreprise
              router-link(to='/favoris', tag='a' @click.native='closeLogin()' class="dropdown-item actions" ) {{ $t('dropdown-menu.favoris') }}
              router-link(to='/cdc', tag='a' @click.native='closeLogin()' class="dropdown-item actions" ) {{ $t('dropdown-menu.cdc') }}
              router-link(to='/notifications', tag='a' @click.native='closeLogin()' class="dropdown-item actions") {{ $t('dropdown-menu.notification') }}
              a.dropdown-item.actions(href="#", @click='logout')
                |  {{ $t('dropdown-menu.deconnexion') }}
        //el-dropdown(v-show='isAuth')
          el-button
            i.fa.fa-user.fa-lg
            | {{profil.nom}}
            i.el-icon-arrow-down.el-icon--right
          el-dropdown-menu(slot='dropdown')
            el-dropdown-item
              router-link(to='/profil', tag='li', class="nav-item")
                a.nav-link.text-primary(href='#') {{ $t('dropdown-menu.profil') }}
            el-dropdown-item
              a(href="#", @click='logout', class="nav-link")
                |  {{ $t('dropdown-menu.deconnexion') }}
</template>
<script>
import Vue from 'vue'
import logo from '@/assets/images/logo.png'
import logo2 from '@/assets/images/logo2.png'
import store from '../store/DataStore'
import { Dropdown, Button, DropdownMenu, DropdownItem } from 'element-ui'
import moment from 'moment'
import Vuex from 'vuex'
import $ from 'jquery'
import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Button)
global.v = Vuex
export default {
  directives: {
    clickoutside: vClickOutside.directive
  },
  store: store,
  data () {
    return {
      impersonationTimer: null,
      isImpersonating: false,
      logo: logo,
      logo2: logo2,
      display: false,
      emailReset: '',
      showProfil: false,
      resetpassword: false,
      email: '',
      password: '',
      hasBlurred: {
        email: false,
        password: false,
        emaillost: false
      },
      messageReset: false
    }
  },
  watch: {
    homeMenu (isHome) {
      window.removeEventListener('scroll', this.homeMenuListener)
      window.removeEventListener('scroll', this.nonHomeMenuListener)
      if (isHome) {
        this.handleHomeMenu()
      } else {
        this.handleNonHomeMenu()
      }
    },
    '$route' () {
      this.display = false
    }
  },
  mounted () {
    if (this.homeMenu) {
      this.handleHomeMenu()
    } else {
      this.handleNonHomeMenu()
    }
  },
  computed: {
    ...Vuex.mapGetters(['isAuth', 'permissions', 'profil', 'homeMenu', 'showLogin', 'loginRedirectIntent']),
    fixedBarStyles () {
      return {
        display: 'flex',
        'flex-direction': 'column'
      }
    }
  },
  methods: {
    canVieWEn () {
      return this.isAuth && this.profil.team != null
    },
    stopImpersonating (skipNotification = false) {
      this.isImpersonating = false
      this.$auth.destroyImpersonationToken()
      clearInterval(this.interval)
      this.interval = null
      if (!skipNotification) {
        setTimeout(() => {
          this.$router.go()
        }, 5000)
        this.$notify({
          title: 'Session terminé',
          message: 'Votre session a expiré, cette page se rechargera automatiquement dans 5 secondes',
          type: 'success',
          duration: 5000,
          showClose: false
        })
      } else {
        this.$router.go()
      }
    },
    reload () {
      setTimeout(() => {
        this.$router.go()
      }, 250)
    },
    onClickOutside () {
      this.closeLogin()
    },
    closeLogin () {
      this.updateShowLogin(false)
      this.showProfil = false
    },
    resetEmail () {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        let data = {
          email: this.emailReset
        }
        window.axios.post('password/forgot', data)
          .then(response => {
            this.$notify({
              title: this.$i18n.t('Réinitialisation de votre mot de passe'),
              message: 'Nous vous avons envoyé un lien',
              type: 'success'
            })
            this.messageReset = true
          })
          .catch(e => {
            if (e.response.status === 422) {
              moment.locale('fr')
              const delay = moment.duration(e.response.data.wait, 'seconds').humanize()
              this.$notify.error({
                title: this.$i18n.t('error.titre-error'),
                message: 'Vous devez attendre ' + delay + ' avant de ressayer'
              })
            } else {
              this.$notify.error({
                title: this.$i18n.t('error.titre-error'),
                message: this.$i18n.t('error.reset-password')
              })
            }
            // this.$notif.display(data)
            // this.messageErreurInscription = e.response.data.errors.email[0]
            // this.erreurInscription = true
          })
      })
    },
    handleHomeMenu () {
      $('body').css('margin-top', '0px')
      this.homeMenuListener()
      window.addEventListener('scroll', this.homeMenuListener)
    },
    handleNonHomeMenu () {
      $('body').css('margin-top', '138px')
      this.nonHomeMenuListener()
      window.addEventListener('scroll', this.nonHomeMenuListener)
      if ($(window).width() < 578) {
        $('body').css('margin-top', '72px')
      }
    },
    nonHomeMenuListener () {
      if ($(document).scrollTop() > 100) {
        $('.navbar').css('padding', '15px 0')
        $('.navbar-brand img').attr('width', '120px')
        $('.navbar-brand img').css('transition', 'all 0.3s ease')
      } else {
        $('.navbar-brand img').attr('src', logo2)
        $('.navbar').css('padding', '45px 0')
        $('.navbar-brand img').attr('width', '120px')
        $('.navbar-brand img').css('transition', 'all 0.3s ease')
      }
      if ($(window).width() < 578) {
        $('.navbar').css('padding', '15px')
      }
    },
    homeMenuListener () {
      if ($(window).width() > 578) {
        if ($(document).scrollTop() > 100) {
          $('.navbar').addClass('navbar-light bg-white shadow ')
          $('.navbar-brand img').attr('src', logo2)
          $('.navbar').css('padding', '15px 0')
          $('.navbar-brand img').attr('width', '120px')
        } else {
          $('.navbar').removeClass('navbar-light bg-white shadow ')
          $('.navbar-brand img').attr('src', logo)
          $('.navbar').css('padding', '45px 0')
          $('.navbar-brand img').css('transition', 'all 0.3s ease')
          $('.navbar-brand img').attr('width', '207px')
        }
      }
    },
    login () {
      // si connexion avec success alors redireger vers profil sinon redireger vers connexion
      let data = {
        username: this.email,
        password: this.password
      }
      // pour la demo en attendent l'api je recupere access_token et expire_in depuis api
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        window.axios.post('oauth/token', data)
          .then(response => {
            // fake session pour faire les traitements apres login
            this.$auth.setToken(response.data.access_token, response.data.expires_in + Date.now())
            store.commit('GET_TOKEN')
            this.isAuthenticatedStrore()
            // cette partie est important pour les redirections
            this.$auth.setStatusCompte('')
            store.commit('STATUS_COMPTE')
            if (this.loginRedirectIntent !== null) {
              const aoId = this.loginRedirectIntent
              this.setLoginRedirectIntent(null)
              this.$router.push(`/ficheappeloffre/${aoId}`, this.reload())
            } else {
              if (response.data.notificationsConfiguré) {
                this.$router.push('/listappeloffre', this.reload())
              } else {
                this.$router.push('/notifications', this.reload())
              }
            }
            // envoi les information du profil
            // this.setUserInformation()
          })
          .catch(e => {
            if (e.response.status === 403) {
              if (e.response.data.hasOwnProperty('account_status')) {
                switch (e.response.data.account_status) {
                  case '0':
                    this.$auth.setToken(e.response.data.access_token, e.response.data.expires_in + Date.now())
                    store.commit('GET_TOKEN')
                    this.$auth.setStatusCompte(e.response.data.account_status)
                    store.commit('STATUS_COMPTE')
                    this.isAuthenticatedStrore()
                    this.closeLogin()
                    this.$router.push('/smsvalidation')
                    setTimeout(() => {
                      location.reload()
                    }, 50)
                    break
                  case '1':
                    this.$auth.setToken(e.response.data.access_token, e.response.data.expires_in + Date.now())
                    store.commit('GET_TOKEN')
                    this.$auth.setStatusCompte(e.response.data.account_status)
                    store.commit('STATUS_COMPTE')
                    this.isAuthenticatedStrore()
                    this.closeLogin()
                    this.$router.push('/verificationemail')
                    setTimeout(() => {
                      location.reload()
                    }, 50)
                    break
                }
              } else {
                this.closeLogin()
                this.$notify.error({
                  title: 'Erreur connexion',
                  message: 'Votre compte a été desactivé'
                })
              }
              // this.$router.go()
            } else {
              this.messageErreurInscription = e.response.data.message
              // e.response.data.account_status e.response.data.message
              this.$notify.error({
                title: 'Erreur connexion',
                message: 'Adresse e-mail ou mot de passe incorrect'
              })
              switch (e.response.data.account_status) {
                case 0:
                  this.messageErreurInscription = 'Votre email n\'est pas encore valider'
                  break
                case 1:
                  this.messageErreurInscription = 'Votre Sms n\'est pas encore valider'
                  break
              }
            }
          })
      })
        .catch(e => {
        })
    },
    ...Vuex.mapActions({isAuthenticatedStrore: 'isAuthenticated', 'getProfilInfoStore': 'getProfilInfo', 'initProfilUserStore': 'initProfilUser', 'updateShowLogin': 'updateShowLogin', 'setLoginRedirectIntent': 'setLoginRedirectIntent'}),
    logout () {
      this.$auth.destroyToken()
      this.isAuthenticatedStrore()
      this.initProfilUserStore()
      this.showProfil = !this.showProfil
      localStorage.clear()
      this.$router.push('/')
    }
  },
  created () {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('impersonate_token')) {
      this.$router.replace(this.$route.path)
    }
    this.isImpersonating = this.$auth.isImpersonating()
    if (this.isImpersonating) {
      this.interval = setInterval(() => {
        const timer = (localStorage.getItem('impersonation_expiration') - Date.now()) / 1000
        if (timer < 0) {
          this.stopImpersonating()
        } else {
          this.impersonationTimer = Math.floor(timer)
        }
      }, 1000)
    }
    if (this.$route.query.message) {
      localStorage.setItem('message', this.$route.query.message)
      this.$router.replace(this.$route.path)
      setTimeout(() => {
        location.reload()
      }, 50)
    }
    if (this.$route.query.reload) {
      if (this.$route.query.reload) {
        localStorage.setItem('validated', 'true')
      }
      this.$router.replace(this.$route.path)
      setTimeout(() => {
        location.reload()
      }, 50)
    }
    if (this.isAuthenticatedStrore()) {
      this.getProfilInfoStore()
      window.store.commit('STATUS_COMPTE')
    }
    // recupere les informations dans chaque referche
  },
  beforeDestroy () {
    if (this.interval !== null) {
      clearInterval(this.interval)
      this.interval = null
    }
  }
}
</script>

<style lang="css">
/* .el-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 0px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
} */
.tf_login input.form-control{
  text-transform: lowercase !important;
}

.tf_login:not(.show){
display: block}

/* Animation */

@keyframes fadeInUp {
  from {
    transform: translate3d(0,40px,0)
  }

  to {
    transform: translate3d(0,0,0);
    opacity: 1
  }
}

@-webkit-keyframes fadeInUp {
  from {
    transform: translate3d(0,40px,0)
  }

  to {
    transform: translate3d(0,0,0);
    opacity: 1
  }
}

.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: both
}

.animatedFadeInUp {
  opacity: 0
}

.fadeInUp {
  opacity: 0;
  animation-name: fadeInUp;
  -webkit-animation-name: fadeInUp;
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue